import Immutable from 'immutable'
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
  SET_FULLSCREEN_LOADER_MESSAGE
} from '../actions/form'

const initialState = Immutable.Map({
  isFullscreenLoaderShown: false,
  fullscreenLoaderMessage: ''
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_FULLSCREEN_LOADER:
      return state
        .set('isFullscreenLoaderShown', true)
        .set('fullscreenLoaderMessage', action.message)
    case HIDE_FULLSCREEN_LOADER:
      return state
        .set('isFullscreenLoaderShown', false)
        .set('fullscreenLoaderMessage', '')
    case SET_FULLSCREEN_LOADER_MESSAGE:
      return state
        .set('fullscreenLoaderMessage', action.message)
    default:
      return state
  }
}
